// src/components/filings/CategoryGrid.jsx
import React from 'react';
import { categoryStyle } from '../../data/filingFieldRegistry';

export default function CategoryGrid({ overview, loading, error, isLoggedIn, onSelectCategory, onApplyHighConviction, onSignIn }) {
  if (loading) {
    return <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>Loading categories…</div>;
  }
  if (error || !overview) {
    return <div style={{ textAlign: 'center', padding: '3rem', color: '#ff4444' }}>{error || 'Categories unavailable'}</div>;
  }

  const { categories, highConvictionCount } = overview;

  return (
    <div>
      {/* High-conviction teaser pill */}
      <div style={{ marginBottom: '1.25rem' }}>
        {isLoggedIn ? (
          <button onClick={onApplyHighConviction}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              padding: '0.55rem 1.1rem', background: 'rgba(255,68,68,0.08)',
              border: '1px solid rgba(255,68,68,0.3)', borderRadius: '20px',
              color: '#ff4444', fontWeight: 800, fontSize: '0.82rem', cursor: 'pointer', fontFamily: 'inherit' }}>
            🚨 {highConvictionCount} High-Conviction Filings Today
          </button>
        ) : (
          <button onClick={onSignIn} title="Sign in to view high-conviction filings"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              padding: '0.55rem 1.1rem', background: 'rgba(100,116,139,0.06)',
              border: '1px solid rgba(100,116,139,0.2)', borderRadius: '20px',
              color: '#64748b', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer', fontFamily: 'inherit' }}>
            🔒 {highConvictionCount} High-Conviction Filings Today — Sign In to View
          </button>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' }}>
        {categories.map(cat => {
          const style = categoryStyle(cat.category);
          return (
            <button key={cat.category} onClick={() => onSelectCategory(cat.category)}
              style={{
                textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit',
                padding: '1.1rem', borderRadius: '14px',
                background: cat.highSignal ? style.color + '0a' : 'rgba(255,255,255,0.03)',
                border: '1px solid ' + (cat.highSignal ? style.color + '30' : 'rgba(255,255,255,0.06)'),
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.6rem' }}>
                <span style={{ fontSize: '1.3rem' }}>{style.icon}</span>
                <span style={{ fontSize: '0.92rem', fontWeight: 800, color: '#f8fafc' }}>{cat.label}</span>
              </div>
              <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '0.5rem' }}>
                {cat.todayCount} today · {cat.totalCount.toLocaleString()} total
              </div>
              {cat.topFiling && (
                <div style={{ fontSize: '0.72rem', color: style.color, fontWeight: 600,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {cat.topFiling.ticker} · {cat.topFiling.filingLabel} · {cat.topFiling.filedAt}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
